export const GREEN_COMPONENTS = {
  // Week 1 Components - Grammar
  "green/week1/grammar/PartsOfSpeechContent": () =>
    import("../green/week1/grammar/PartsOfSpeechContent"),

  // Week 1 Components - Listening
  "green/week1/listening/AcademicListeningIntroContent": () =>
    import("../green/week1/listening/AcademicListeningIntroContent"),
  "green/week1/listening/ListeningVocabularyContent": () =>
    import("../green/week1/listening/ListeningVocabularyContent"),
  "green/week1/listening/PreparingForLecturesContent": () =>
    import("../green/week1/listening/PreparingForLecturesContent"),

  // Week 1 Components - Reading
  "green/week1/reading/AcademicReadingIntroContent": () =>
    import("../green/week1/reading/AcademicReadingIntroContent"),
  "green/week1/reading/CloseReadingSQ3RContent": () =>
    import("../green/week1/reading/CloseReadingSQ3RContent"),
  "green/week1/reading/ReadingVocabularyContent": () =>
    import("../green/week1/reading/ReadingVocabularyContent"),
  "green/week1/reading/SkimmingScanningContent": () =>
    import("../green/week1/reading/SkimmingScanningContent"),

  // Week 1 Components - Review
  "green/week1/review/Week1ReviewContent": () =>
    import("../green/week1/review/Week1ReviewContent"),

  // Week 1 Components - Speaking
  "green/week1/speaking/AcademicSpeakingIntroContent": () =>
    import("../green/week1/speaking/AcademicSpeakingIntroContent"),

  // Week 1 Components - Vocabulary
  "green/week1/vocabulary/Week1VocabularyContent": () =>
    import("../green/week1/vocabulary/Week1VocabularyContent"),

  // Week 1 Components - Writing
  "green/week1/writing/AcademicStyleContent": () =>
    import("../green/week1/writing/AcademicStyleContent"),
  "green/week1/writing/AcademicWritingIntroContent": () =>
    import("../green/week1/writing/AcademicWritingIntroContent"),

  // Week 2 Components - Grammar
  "green/week2/grammar/GrammarVocabularyContent": () =>
    import("../green/week2/grammar/GrammarVocabularyContent"),
  "green/week2/grammar/WordBuildingContent": () =>
    import("../green/week2/grammar/WordBuildingContent"),

  // Week 2 Components - Listening
  "green/week2/listening/ListeningVocabularyContent": () =>
    import("../green/week2/listening/ListeningVocabularyContent"),
  "green/week2/listening/NoteTakingSkillsContent": () =>
    import("../green/week2/listening/NoteTakingSkillsContent"),

  // Week 2 Components - Reading
  "green/week2/reading/CriticalReadingContent": () =>
    import("../green/week2/reading/CriticalReadingContent"),
  "green/week2/reading/ReadingVocabularyContent": () =>
    import("../green/week2/reading/ReadingVocabularyContent"),

  // Week 2 Components - Review
  "green/week2/review/Week2ReviewContent": () =>
    import("../green/week2/review/Week2ReviewContent"),

  // Week 2 Components - Speaking
  "green/week2/speaking/RequestingInformationContent": () =>
    import("../green/week2/speaking/RequestingInformationContent"),
  "green/week2/speaking/SpeakingVocabularyContent": () =>
    import("../green/week2/speaking/SpeakingVocabularyContent"),

  // Week 2 Components - Vocabulary
  "green/week2/vocabulary/Week2VocabularyContent": () =>
    import("../green/week2/vocabulary/Week2VocabularyContent"),

  // Week 2 Components - Writing
  "green/week2/writing/WritingProcessContent": () =>
    import("../green/week2/writing/WritingProcessContent"),
  "green/week2/writing/WritingVocabularyContent": () =>
    import("../green/week2/writing/WritingVocabularyContent"),

  // Week 3 Components - Grammar
  "green/week3/grammar/CompoundWordsContent": () =>
    import("../green/week3/grammar/CompoundWordsContent"),
  "green/week3/grammar/GrammarVocabularyContent": () =>
    import("../green/week3/grammar/GrammarVocabularyContent"),

  // Week 3 Components - Listening
  "green/week3/listening/LectureIntroductionsContent": () =>
    import("../green/week3/listening/LectureIntroductionsContent"),
  "green/week3/listening/ListeningVocabularyContent": () =>
    import("../green/week3/listening/ListeningVocabularyContent"),

  // Week 3 Components - Reading
  "green/week3/reading/GlancingPreviewingContent": () =>
    import("../green/week3/reading/GlancingPreviewingContent"),
  "green/week3/reading/ReadingVocabularyContent": () =>
    import("../green/week3/reading/ReadingVocabularyContent"),

  // Week 3 Components - Review
  "green/week3/review/Week3ReviewContent": () =>
    import("../green/week3/review/Week3ReviewContent"),

  // Week 3 Components - Speaking
  "green/week3/speaking/PresentationIntroductionsContent": () =>
    import("../green/week3/speaking/PresentationIntroductionsContent"),
  "green/week3/speaking/SpeakingVocabularyContent": () =>
    import("../green/week3/speaking/SpeakingVocabularyContent"),

  // Week 3 Components - Vocabulary
  "green/week3/vocabulary/Week3VocabularyContent": () =>
    import("../green/week3/vocabulary/Week3VocabularyContent"),

  // Week 3 Components - Writing
  "green/week3/writing/LinkingWordsCohesionContent": () =>
    import("../green/week3/writing/LinkingWordsCohesionContent"),
  "green/week3/writing/ParagraphStructureContent": () =>
    import("../green/week3/writing/ParagraphStructureContent"),
  "green/week3/writing/WritingVocabularyContent": () =>
    import("../green/week3/writing/WritingVocabularyContent"),

  // Week 4 Components - Grammar
  "green/week4/grammar/GrammarVocabularyContent": () =>
    import("../green/week4/grammar/GrammarVocabularyContent"),
  "green/week4/grammar/PassiveVoiceContent": () =>
    import("../green/week4/grammar/PassiveVoiceContent"),

  // Week 4 Components - Listening
  "green/week4/listening/CueWordsContent": () =>
    import("../green/week4/listening/CueWordsContent"),
  "green/week4/listening/ListeningVocabularyContent": () =>
    import("../green/week4/listening/ListeningVocabularyContent"),

  // Week 4 Components - Reading
  "green/week4/reading/ReadingVocabularyContent": () =>
    import("../green/week4/reading/ReadingVocabularyContent"),
  "green/week4/reading/SkimmingScanningContent": () =>
    import("../green/week4/reading/SkimmingScanningContent"),

  // Week 4 Components - Review
  "green/week4/review/Week4ReviewContent": () =>
    import("../green/week4/review/Week4ReviewContent"),

  // Week 4 Components - Speaking
  "green/week4/speaking/PresentationCueWordsContent": () =>
    import("../green/week4/speaking/PresentationCueWordsContent"),
  "green/week4/speaking/SpeakingVocabularyContent": () =>
    import("../green/week4/speaking/SpeakingVocabularyContent"),

  // Week 4 Components - Vocabulary
  "green/week4/vocabulary/Week4VocabularyContent": () =>
    import("../green/week4/vocabulary/Week4VocabularyContent"),

  // Week 4 Components - Writing
  "green/week4/writing/EssayStructureContent": () =>
    import("../green/week4/writing/EssayStructureContent"),
  "green/week4/writing/WritingVocabularyContent": () =>
    import("../green/week4/writing/WritingVocabularyContent"),

  // Week 5 Components - Grammar
  "green/week5/grammar/GrammarVocabularyContent": () =>
    import("../green/week5/grammar/GrammarVocabularyContent"),
  "green/week5/grammar/QuantifyingExpressionsContent": () =>
    import("../green/week5/grammar/QuantifyingExpressionsContent"),

  // Week 5 Components - Listening
  "green/week5/listening/ListeningVocabularyContent": () =>
    import("../green/week5/listening/ListeningVocabularyContent"),
  "green/week5/listening/SummariesUnderstandingContent": () =>
    import("../green/week5/listening/SummariesUnderstandingContent"),

  // Week 5 Components - Reading
  "green/week5/reading/ReadingVocabularyContent": () =>
    import("../green/week5/reading/ReadingVocabularyContent"),
  "green/week5/reading/SummaryWritingContent": () =>
    import("../green/week5/reading/SummaryWritingContent"),

  // Week 5 Components - Review
  "green/week5/review/Week5ReviewContent": () =>
    import("../green/week5/review/Week5ReviewContent"),

  // Week 5 Components - Speaking
  "green/week5/speaking/SpeakingVocabularyContent": () =>
    import("../green/week5/speaking/SpeakingVocabularyContent"),
  "green/week5/speaking/SummingUpContent": () =>
    import("../green/week5/speaking/SummingUpContent"),

  // Week 5 Components - Vocabulary
  "green/week5/vocabulary/Week5VocabularyContent": () =>
    import("../green/week5/vocabulary/Week5VocabularyContent"),

  // Week 5 Components - Writing
  "green/week5/writing/WritingSummaryContent": () =>
    import("../green/week5/writing/WritingSummaryContent"),
  "green/week5/writing/WritingVocabularyContent": () =>
    import("../green/week5/writing/WritingVocabularyContent"),

  // Week 6 Components - Grammar
  "green/week6/grammar/ModalExpressionsContent": () =>
    import("../green/week6/grammar/ModalExpressionsContent"),

  // Week 6 Components - Listening
  "green/week6/listening/LanguageOfCertaintyContent": () =>
    import("../green/week6/listening/LanguageOfCertaintyContent"),
  "green/week6/listening/ListeningVocabularyContent": () =>
    import("../green/week6/listening/ListeningVocabularyContent"),

  // Week 6 Components - Reading
  "green/week6/reading/ReadingVocabularyContent": () =>
    import("../green/week6/reading/ReadingVocabularyContent"),
  "green/week6/reading/SQ3RMethodContent": () =>
    import("../green/week6/reading/SQ3RMethodContent"),

  // Week 6 Components - Review
  "green/week6/review/Week6ReviewContent": () =>
    import("../green/week6/review/Week6ReviewContent"),

  // Week 6 Components - Speaking
  "green/week6/speaking/CertaintyInSpeakingContent": () =>
    import("../green/week6/speaking/CertaintyInSpeakingContent"),
  "green/week6/speaking/SpeakingVocabularyContent": () =>
    import("../green/week6/speaking/SpeakingVocabularyContent"),

  // Week 6 Components - Vocabulary
  "green/week6/vocabulary/Week6VocabularyContent": () =>
    import("../green/week6/vocabulary/Week6VocabularyContent"),

  // Week 6 Components - Writing
  "green/week6/writing/HedgingLanguageContent": () =>
    import("../green/week6/writing/HedgingLanguageContent"),
  "green/week6/writing/WritingVocabularyContent": () =>
    import("../green/week6/writing/WritingVocabularyContent"),

  // Week 7 Components - Grammar
  "green/week7/grammar/ConjunctionsSubordinatorsContent": () =>
    import("../green/week7/grammar/ConjunctionsSubordinatorsContent"),

  // Week 7 Components - Listening
  "green/week7/listening/DifferentViewsContent": () =>
    import("../green/week7/listening/DifferentViewsContent"),
  "green/week7/listening/ListeningVocabularyContent": () =>
    import("../green/week7/listening/ListeningVocabularyContent"),

  // Week 7 Components - Reading
  "green/week7/reading/IdentifyingViewpointsContent": () =>
    import("../green/week7/reading/IdentifyingViewpointsContent"),
  "green/week7/reading/ReadingVocabularyContent": () =>
    import("../green/week7/reading/ReadingVocabularyContent"),

  // Week 7 Components - Review
  "green/week7/review/Week7ReviewContent": () =>
    import("../green/week7/review/Week7ReviewContent"),

  // Week 7 Components - Speaking
  "green/week7/speaking/PresentingViewsContent": () =>
    import("../green/week7/speaking/PresentingViewsContent"),
  "green/week7/speaking/SpeakingVocabularyContent": () =>
    import("../green/week7/speaking/SpeakingVocabularyContent"),

  // Week 7 Components - Vocabulary
  "green/week7/vocabulary/Week7VocabularyContent": () =>
    import("../green/week7/vocabulary/Week7VocabularyContent"),

  // Week 7 Components - Writing
  "green/week7/writing/DiscussionEssaysContent": () =>
    import("../green/week7/writing/DiscussionEssaysContent"),
  "green/week7/writing/WritingVocabularyContent": () =>
    import("../green/week7/writing/WritingVocabularyContent"),

  // Week 8 Components - Grammar
  "green/week8/grammar/SubordinatorsReviewContent": () =>
    import("../green/week8/grammar/SubordinatorsReviewContent"),

  // Week 8 Components - Listening
  "green/week8/listening/ListeningVocabularyContent": () =>
    import("../green/week8/listening/ListeningVocabularyContent"),
  "green/week8/listening/PurposesMeansMethodsContent": () =>
    import("../green/week8/listening/PurposesMeansMethodsContent"),

  // Week 8 Components - Reading
  "green/week8/reading/ReadingVocabularyContent": () =>
    import("../green/week8/reading/ReadingVocabularyContent"),
  "green/week8/reading/TextGenresContent": () =>
    import("../green/week8/reading/TextGenresContent"),

  // Week 8 Components - Review
  "green/week8/review/Week8ReviewContent": () =>
    import("../green/week8/review/Week8ReviewContent"),

  // Week 8 Components - Speaking
  "green/week8/speaking/ExplainingPurposesContent": () =>
    import("../green/week8/speaking/ExplainingPurposesContent"),
  "green/week8/speaking/SpeakingVocabularyContent": () =>
    import("../green/week8/speaking/SpeakingVocabularyContent"),

  // Week 8 Components - Vocabulary
  "green/week8/vocabulary/Week8VocabularyContent": () =>
    import("../green/week8/vocabulary/Week8VocabularyContent"),

  // Week 8 Components - Writing
  "green/week8/writing/MethodsSectionContent": () =>
    import("../green/week8/writing/MethodsSectionContent"),
  "green/week8/writing/WritingVocabularyContent": () =>
    import("../green/week8/writing/WritingVocabularyContent"),

  // Week 9 Components - Grammar
  "green/week9/grammar/AdjectiveClausesContent": () =>
    import("../green/week9/grammar/AdjectiveClausesContent"),

  // Week 9 Components - Listening
  "green/week9/listening/ListeningVocabularyContent": () =>
    import("../green/week9/listening/ListeningVocabularyContent"),
  "green/week9/listening/SequencesTimeRelationsContent": () =>
    import("../green/week9/listening/SequencesTimeRelationsContent"),

  // Week 9 Components - Reading
  "green/week9/reading/IdeaRelationshipsContent": () =>
    import("../green/week9/reading/IdeaRelationshipsContent"),
  "green/week9/reading/ReadingVocabularyContent": () =>
    import("../green/week9/reading/ReadingVocabularyContent"),

  // Week 9 Components - Review
  "green/week9/review/Week9ReviewContent": () =>
    import("../green/week9/review/Week9ReviewContent"),

  // Week 9 Components - Speaking
  "green/week9/speaking/SpeakingVocabularyContent": () =>
    import("../green/week9/speaking/SpeakingVocabularyContent"),
  "green/week9/speaking/TimeOrderSpeakingContent": () =>
    import("../green/week9/speaking/TimeOrderSpeakingContent"),

  // Week 9 Components - Vocabulary
  "green/week9/vocabulary/Week9VocabularyContent": () =>
    import("../green/week9/vocabulary/Week9VocabularyContent"),

  // Week 9 Components - Writing
  "green/week9/writing/TimeSignalsContent": () =>
    import("../green/week9/writing/TimeSignalsContent"),
  "green/week9/writing/WritingVocabularyContent": () =>
    import("../green/week9/writing/WritingVocabularyContent"),

  // Week 10 Components - Grammar
  "green/week10/grammar/ParticiplePhrasesContent": () =>
    import("../green/week10/grammar/ParticiplePhrasesContent"),

  // Week 10 Components - Listening
  "green/week10/listening/DevelopmentsChangesContent": () =>
    import("../green/week10/listening/DevelopmentsChangesContent"),
  "green/week10/listening/ListeningVocabularyContent": () =>
    import("../green/week10/listening/ListeningVocabularyContent"),

  // Week 10 Components - Reading
  "green/week10/reading/ReadingVocabularyContent": () =>
    import("../green/week10/reading/ReadingVocabularyContent"),
  "green/week10/reading/TrendsChangesContent": () =>
    import("../green/week10/reading/TrendsChangesContent"),

  // Week 10 Components - Review
  "green/week10/review/Week10ReviewContent": () =>
    import("../green/week10/review/Week10ReviewContent"),

  // Week 10 Components - Speaking
  "green/week10/speaking/DiscussingChangesContent": () =>
    import("../green/week10/speaking/DiscussingChangesContent"),
  "green/week10/speaking/SpeakingVocabularyContent": () =>
    import("../green/week10/speaking/SpeakingVocabularyContent"),

  // Week 10 Components - Vocabulary
  "green/week10/vocabulary/Week10VocabularyContent": () =>
    import("../green/week10/vocabulary/Week10VocabularyContent"),

  // Week 10 Components - Writing
  "green/week10/writing/DescribingChangesContent": () =>
    import("../green/week10/writing/DescribingChangesContent"),
  "green/week10/writing/WritingVocabularyContent": () =>
    import("../green/week10/writing/WritingVocabularyContent"),

  // Week 11 Components - Grammar
  "green/week11/grammar/AdverbPhrasesClausesContent": () =>
    import("../green/week11/grammar/AdverbPhrasesClausesContent"),

  // Week 11 Components - Listening
  "green/week11/listening/ListeningArgumentsContent": () =>
    import("../green/week11/listening/ListeningArgumentsContent"),
  "green/week11/listening/ListeningVocabularyContent": () =>
    import("../green/week11/listening/ListeningVocabularyContent"),

  // Week 11 Components - Reading
  "green/week11/reading/IdentifyingArgumentsContent": () =>
    import("../green/week11/reading/IdentifyingArgumentsContent"),
  "green/week11/reading/ReadingVocabularyContent": () =>
    import("../green/week11/reading/ReadingVocabularyContent"),

  // Week 11 Components - Review
  "green/week11/review/Week11ReviewContent": () =>
    import("../green/week11/review/Week11ReviewContent"),

  // Week 11 Components - Speaking
  "green/week11/speaking/PresentingArgumentsContent": () =>
    import("../green/week11/speaking/PresentingArgumentsContent"),
  "green/week11/speaking/SpeakingVocabularyContent": () =>
    import("../green/week11/speaking/SpeakingVocabularyContent"),

  // Week 11 Components - Vocabulary
  "green/week11/vocabulary/Week11VocabularyContent": () =>
    import("../green/week11/vocabulary/Week11VocabularyContent"),

  // Week 11 Components - Writing
  "green/week11/writing/ConstructingArgumentsContent": () =>
    import("../green/week11/writing/ConstructingArgumentsContent"),
  "green/week11/writing/WritingVocabularyContent": () =>
    import("../green/week11/writing/WritingVocabularyContent"),

  // Week 12 Components - Grammar
  "green/week12/grammar/NounPhrasesContent": () =>
    import("../green/week12/grammar/NounPhrasesContent"),

  // Week 12 Components - Listening
  "green/week12/listening/FactsOpinionsContent": () =>
    import("../green/week12/listening/FactsOpinionsContent"),

  // Week 12 Components - Reading
  "green/week12/reading/DistinguishingFactOpinionContent": () =>
    import("../green/week12/reading/DistinguishingFactOpinionContent"),

  // Week 12 Components - Review
  "green/week12/review/Week12ReviewContent": () =>
    import("../green/week12/review/Week12ReviewContent"),

  // Week 12 Components - Speaking
  "green/week12/speaking/GivingOpinionsContent": () =>
    import("../green/week12/speaking/GivingOpinionsContent"),

  // Week 12 Components - Vocabulary
  "green/week12/vocabulary/Week12VocabularyContent": () =>
    import("../green/week12/vocabulary/Week12VocabularyContent"),

  // Week 12 Components - Writing
  "green/week12/writing/SupportingArgumentsContent": () =>
    import("../green/week12/writing/SupportingArgumentsContent"),

  // Week 13 Components - Grammar
  "green/week13/grammar/NounClausesContent": () =>
    import("../green/week13/grammar/NounClausesContent"),

  // Week 13 Components - Listening
  "green/week13/listening/EvaluatingLecturesContent": () =>
    import("../green/week13/listening/EvaluatingLecturesContent"),

  // Week 13 Components - Reading
  "green/week13/reading/EvaluatingArgumentsContent": () =>
    import("../green/week13/reading/EvaluatingArgumentsContent"),

  // Week 13 Components - Review
  "green/week13/review/Week13ReviewContent": () =>
    import("../green/week13/review/Week13ReviewContent"),

  // Week 13 Components - Speaking
  "green/week13/speaking/AgreeingDisagreeingContent": () =>
    import("../green/week13/speaking/AgreeingDisagreeingContent"),

  // Week 13 Components - Vocabulary
  "green/week13/vocabulary/Week13VocabularyContent": () =>
    import("../green/week13/vocabulary/Week13VocabularyContent"),

  // Week 13 Components - Writing
  "green/week13/writing/WritingEvaluationsContent": () =>
    import("../green/week13/writing/WritingEvaluationsContent"),

  // Week 14 Components - Grammar
  "green/week14/grammar/ReportedSpeechContent": () =>
    import("../green/week14/grammar/ReportedSpeechContent"),

  // Week 14 Components - Listening
  "green/week14/listening/ExternalReferencesContent": () =>
    import("../green/week14/listening/ExternalReferencesContent"),

  // Week 14 Components - Reading
  "green/week14/reading/ReferencingSourcesContent": () =>
    import("../green/week14/reading/ReferencingSourcesContent"),

  // Week 14 Components - Review
  "green/week14/review/Week14ReviewContent": () =>
    import("../green/week14/review/Week14ReviewContent"),

  // Week 14 Components - Speaking
  "green/week14/speaking/ReferringToSourcesContent": () =>
    import("../green/week14/speaking/ReferringToSourcesContent"),

  // Week 14 Components - Vocabulary
  "green/week14/vocabulary/AcademicCollocationsContent": () =>
    import("../green/week14/vocabulary/AcademicCollocationsContent"),

  // Week 14 Components - Writing
  "green/week14/writing/ParaphrasingSummarizingContent": () =>
    import("../green/week14/writing/ParaphrasingSummarizingContent"),

  // Week 15 Components - Grammar
  "green/week15/grammar/ArticlesContent": () =>
    import("../green/week15/grammar/ArticlesContent"),

  // Week 15 Components - Listening
  "green/week15/listening/ExamplesInLecturesContent": () =>
    import("../green/week15/listening/ExamplesInLecturesContent"),

  // Week 15 Components - Reading
  "green/week15/reading/InferredMeaningContent": () =>
    import("../green/week15/reading/InferredMeaningContent"),

  // Week 15 Components - Review
  "green/week15/review/Week15ReviewContent": () =>
    import("../green/week15/review/Week15ReviewContent"),

  // Week 15 Components - Speaking
  "green/week15/speaking/GivingExamplesContent": () =>
    import("../green/week15/speaking/GivingExamplesContent"),

  // Week 15 Components - Vocabulary
  "green/week15/vocabulary/AcademicCollocationsContent": () =>
    import("../green/week15/vocabulary/AcademicCollocationsContent"),

  // Week 15 Components - Writing
  "green/week15/writing/ReportingVerbsContent": () =>
    import("../green/week15/writing/ReportingVerbsContent"),

  // Week 16 Components - Grammar
  "green/week16/grammar/ComparisonContrastLinkersContent": () =>
    import("../green/week16/grammar/ComparisonContrastLinkersContent"),

  // Week 16 Components - Listening
  "green/week16/listening/ComparisonsContrastsListeningContent": () =>
    import("../green/week16/listening/ComparisonsContrastsListeningContent"),

  // Week 16 Components - Reading
  "green/week16/reading/ComparativeStructuresReadingContent": () =>
    import("../green/week16/reading/ComparativeStructuresReadingContent"),

  // Week 16 Components - Review
  "green/week16/review/Week16ReviewContent": () =>
    import("../green/week16/review/Week16ReviewContent"),

  // Week 16 Components - Speaking
  "green/week16/speaking/CompareContrastDiscussionsContent": () =>
    import("../green/week16/speaking/CompareContrastDiscussionsContent"),

  // Week 16 Components - Vocabulary
  "green/week16/vocabulary/Week16VocabularyContent": () =>
    import("../green/week16/vocabulary/Week16VocabularyContent"),

  // Week 16 Components - Writing
  "green/week16/writing/SimilaritiesDifferencesWritingContent": () =>
    import("../green/week16/writing/SimilaritiesDifferencesWritingContent"),

  // Week 17 Components - Grammar
  "green/week17/grammar/SubjectVerbAgreementContent": () =>
    import("../green/week17/grammar/SubjectVerbAgreementContent"),

  // Week 17 Components - Listening
  "green/week17/listening/EmphasisIntonationListeningContent": () =>
    import("../green/week17/listening/EmphasisIntonationListeningContent"),

  // Week 17 Components - Reading
  "green/week17/reading/GuessingMeaningContextContent": () =>
    import("../green/week17/reading/GuessingMeaningContextContent"),

  // Week 17 Components - Review
  "green/week17/review/Week17ReviewContent": () =>
    import("../green/week17/review/Week17ReviewContent"),

  // Week 17 Components - Speaking
  "green/week17/speaking/EmphasisInterruptingSuggestionsContent": () =>
    import("../green/week17/speaking/EmphasisInterruptingSuggestionsContent"),

  // Week 17 Components - Vocabulary
  "green/week17/vocabulary/Week17VocabularyContent": () =>
    import("../green/week17/vocabulary/Week17VocabularyContent"),

  // Week 17 Components - Writing
  "green/week17/writing/IntegratingSynthesizingWritingContent": () =>
    import("../green/week17/writing/IntegratingSynthesizingWritingContent"),

  // Week 18 Components - Grammar
  "green/week18/grammar/DeterminersContent": () =>
    import("../green/week18/grammar/DeterminersContent"),

  // Week 18 Components - Listening
  "green/week18/listening/UnderstandingInstructionsContent": () =>
    import("../green/week18/listening/UnderstandingInstructionsContent"),

  // Week 18 Components - Reading
  "green/week18/reading/ClozeTestsContent": () =>
    import("../green/week18/reading/ClozeTestsContent"),

  // Week 18 Components - Review
  "green/week18/review/Week18ReviewContent": () =>
    import("../green/week18/review/Week18ReviewContent"),

  // Week 18 Components - Speaking
  "green/week18/speaking/DiscussingInstructionsContent": () =>
    import("../green/week18/speaking/DiscussingInstructionsContent"),

  // Week 18 Components - Vocabulary
  "green/week18/vocabulary/AcademicCollocationsContent": () =>
    import("../green/week18/vocabulary/AcademicCollocationsContent"),

  // Week 18 Components - Writing
  "green/week18/writing/ReferenceListsContent": () =>
    import("../green/week18/writing/ReferenceListsContent"),

  // Week 19 Components - Grammar
  "green/week19/grammar/GrammarConsolidationContent": () =>
    import("../green/week19/grammar/GrammarConsolidationContent"),

  // Week 19 Components - Listening
  "green/week19/listening/DiscussionsDebatesContent": () =>
    import("../green/week19/listening/DiscussionsDebatesContent"),

  // Week 19 Components - Reading
  "green/week19/reading/JournalArticlesContent": () =>
    import("../green/week19/reading/JournalArticlesContent"),

  // Week 19 Components - Review
  "green/week19/review/Week19ReviewContent": () =>
    import("../green/week19/review/Week19ReviewContent"),

  // Week 19 Components - Speaking
  "green/week19/speaking/AcademicDiscussionsContent": () =>
    import("../green/week19/speaking/AcademicDiscussionsContent"),

  // Week 19 Components - Vocabulary
  "green/week19/vocabulary/EnvironmentalVocabularyContent": () =>
    import("../green/week19/vocabulary/EnvironmentalVocabularyContent"),

  // Week 19 Components - Writing
  "green/week19/writing/WritingConsolidationContent": () =>
    import("../green/week19/writing/WritingConsolidationContent"),
  // Week 20 Components - Grammar
  "green/week20/grammar/GrammarReviewContent": () =>
    import("../green/week20/grammar/GrammarReviewContent"),

  // Week 20 Components - Listening
  "green/week20/listening/ListeningStrategiesReviewContent": () =>
    import("../green/week20/listening/ListeningStrategiesReviewContent"),

  // Week 20 Components - Reading
  "green/week20/reading/ReadingSkillsReviewContent": () =>
    import("../green/week20/reading/ReadingSkillsReviewContent"),

  // Week 20 Components - Review
  "green/week20/review/Week20ReviewContent": () =>
    import("../green/week20/review/Week20ReviewContent"),

  // Week 20 Components - Speaking
  "green/week20/speaking/SpeakingSkillsReviewContent": () =>
    import("../green/week20/speaking/SpeakingSkillsReviewContent"),

  // Week 20 Components - Vocabulary
  "green/week20/vocabulary/VocabularyReviewContent": () =>
    import("../green/week20/vocabulary/VocabularyReviewContent"),

  // Week 20 Components - Writing
  "green/week20/writing/WritingSkillsReviewContent": () =>
    import("../green/week20/writing/WritingSkillsReviewContent"),
} as const;
